import type { IUserProfileRepository } from "@/application/ports/repositories";
import type {
  UpdateUserProfileRequest,
  ChangePasswordRequest,
  UserPreferences,
  UpdateUserPreferencesRequest,
  UserProfileResponse,
  UpdateUserProfileWithAvatarRequest,
} from "@/domain/user";
import * as sdk from "../generated/sdk.gen";
import { unwrap } from "../unwrap";

const DEFAULT_PREFERENCES: UserPreferences = {
  prefers_dark_mode: false,
  prefers_compact_view: false,
  language: "es",
  timezone: "Europe/Madrid",
  notifications_enabled: true,
  notify_via_email: true,
  notify_via_app: true,
};

export class UserProfileRepository implements IUserProfileRepository {
  async updateProfile(data: UpdateUserProfileRequest): Promise<UserProfileResponse> {
    return unwrap(sdk.updateMe({ body: data }));
  }
  async updateProfileWithAvatar(
    data: UpdateUserProfileWithAvatarRequest,
  ): Promise<UserProfileResponse> {
    return unwrap(sdk.updateMe({ body: data }));
  }
  async changePassword(data: ChangePasswordRequest): Promise<void> {
    await unwrap(sdk.changePassword({ body: data }));
  }
  async getPreferences(): Promise<UserPreferences> {
    const profile = await unwrap(sdk.getMe());
    return profile.preferences ?? DEFAULT_PREFERENCES;
  }
  async updatePreferences(data: UpdateUserPreferencesRequest): Promise<UserPreferences> {
    const profile = await unwrap(sdk.updateMe({ body: { preferences: data } }));
    return profile.preferences ?? DEFAULT_PREFERENCES;
  }
}
